import { codeHash } from '../../session/testResults'

// What a study condition's tutor cannot tell from one question's context, added under its
// TEST RESULTS (the server's session notes say the context does so when it can tell): whether
// the student changed the code after the run those results come from, and how the results
// moved since the student's previous question. From E2 a question-first tutor itself tells a
// new problem from a continuing one, so it needs to see progress. '' when there is nothing.

// { passed, total } of a page's per-test results, or null before any run.
export const testSummary = (testResults) =>
  Array.isArray(testResults) && testResults.length
    ? { passed: testResults.filter((passed) => passed === true).length, total: testResults.length }
    : null

// earlier: testSummary at the student's previous question on this page - undefined when this is
// their first question since the page loaded, null when they had not run the tests yet.
export const studyRunNote = ({ code, lastRunInfo, testResults, earlier }) => {
  const notes = []
  if (lastRunInfo?.codeHash && codeHash(code) !== lastRunInfo.codeHash) {
    notes.push('The code above has changed since this run: these results and the terminal output are from an earlier version of the code.')
  }
  const now = testSummary(testResults)
  if (earlier !== undefined && now) {
    notes.push(
      earlier
        ? `When the student last asked you, ${earlier.passed} of ${earlier.total} tests passed; now ${now.passed} of ${now.total} pass.`
        : `When the student last asked you, they had not run the tests yet; now ${now.passed} of ${now.total} pass.`
    )
  }
  return notes.join('\n')
}
